import React from 'react'
import { Text } from 'rebass/styled-components'
import { FormattedMessage } from 'react-intl'
import { Links } from './Links'
import styles from './HoverMenu.module.css'

interface HoverMenuProps {
  labelId: string
  teamName?: string
  children?: React.ReactNode
  links: any[] // Using any to match existing Links component props
  can: (permission: string) => boolean
  forceRefresh?: boolean
  orgId?: string
  siteId?: string
  teamId?: string
  uuid?: string
  shareToken?: string
}

export const HoverMenu = ({
  labelId,
  teamName,
  links,
  can,
  forceRefresh,
  orgId,
  siteId,
  teamId,
  uuid,
  shareToken
}: HoverMenuProps): JSX.Element => {
  return (
    <div className={styles.hoverMenu}>
      <Text className={styles.hoverMenuHeading}>
        <FormattedMessage id={`${labelId}.label`} values={{ teamName }} />
      </Text>
      <div className={styles.hoverMenuLinks}>
        <Links
          can={can}
          forceRefresh={forceRefresh}
          links={links}
          orgId={orgId}
          siteId={siteId}
          teamId={teamId}
          uuid={uuid}
          shareToken={shareToken}
        />
      </div>
    </div>
  )
}
